import { useIntl } from "react-intl";
import { HairProductKey } from "~/api/models/HairProductKey";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import ProductCard from "~/components/organisms/Pricing/ProductCard/ProductCard";
import useHairProducts from "~/hooks/useHairProducts";
import { Product } from "~/stores/checkout/product";

const BeardCard = () => {
  const intl = useIntl();
  const { data: allProducts, isLoading } = useFetchProducts();
  const { beardProduct, setBeardProduct } = useHairProducts();

  return (
    <ProductCard
      hairProductFamilyKey={HairProductKey.beard}
      cardTitle={intl.formatMessage({
        id: "pricing.beard",
      })}
      product={beardProduct}
      setProduct={
        setBeardProduct as (product?: Product | Product[] | undefined) => void
      }
      modalTitle={intl.formatMessage({ id: "pricing.modal.beard.title" })}
      blankOptionTitle={intl.formatMessage({
        id: "treatment.pricing.beard.none",
      })}
      isLoading={isLoading}
      options={allProducts.hair.beard.transplantation}
      optionSubtitleFormatter={(option) =>
        intl.formatMessage(
          {
            id: "graftsCount",
          },
          {
            from: option?.grafts.from,
            to: option?.grafts.to,
          }
        )
      }
      optionTitleFormatter={(option) => option.name.split("(")[0]}
    />
  );
};

export default BeardCard;
